import {sequence} from '@gongxigames/framework/slotV2/fsm/acts/ActFactory';
import {slotStore} from '@gongxigames/framework/slotV2/globals';
import {UIState} from '@gongxigames/framework/slotV2/baseClasses/uiState/UIState';
import {PickBonusUIAct} from '@gongxigames/framework/slotV2/ui/acts/PickBonusUIAct';

export class PickBonusUIState extends UIState {
    public static readonly ID = 'PickBonusUIState';

    public setAct(): void {
        this.act = sequence([
            PickBonusUIAct
        ]);
    }

    public canExecute(): boolean {
        return slotStore.feature_type.value?.type === 'pickBonus';
    }
}